/** @format */

export async function handleResponse(response) {
  return await response.json();
}

export async function handleError(error) {
  return new Error(error);
}
